// axios 请求封装
import axios from 'axios'
import $qs from 'qs'

// 服务器配置地址
axios.defaults.baseURL = 'https://ApiWebsite.bscd8.com/api/'
// let token = ''
// if (localStorage.getItem('vegetarian_token') !== null) {
//   token = localStorage.getItem('vegetarian_token')
// }
// 请求拦截
axios.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data)
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-TOKEN': localStorage.getItem('vegetarian_token')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

// 封装 GET POST
export default {
  post (url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, $qs.stringify(data))
        .then(response => {
          resolve(response.data)
        }, err => {
          reject(err)
        })
    })
  },
  get (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params: params
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/http/index.js